import * as React from 'react';

import { useColumnSortReducer } from '~teacher/components/quizzes';
import { LibraryPanel } from '~teacher/components/quizzes/LibraryPanel/LibaryPanel';
import { useFilteredSortedQuizListItems } from '~teacher/components/quizzes/QuizList/useFilteredSortedQuizListItems';
import { getFreeQuizzesFilter } from '~teacher/components/quizzes/QuizListFilters/getFreeQuizzesFilter';
import { useQuizzes } from '~teacher/hook';
import { sortQuizListItems } from '~teacher/pages/sortQuizListItems';

import { QuizOrFolder } from '../../../../api/quiz/getQuizzes/types';
import { personalQuizUrl as quizUrl } from '../../../../api/urls';

export function LibraryPanelFree() {
  const quizzes = useQuizzes();

  const [
    { direction: sortDirection, quizListColumn: sortProperty },
    dispatchColumnSortAction,
  ] = useColumnSortReducer();

  const sortQuizItems = React.useCallback(
    (items: QuizOrFolder[]): QuizOrFolder[] =>
      sortQuizListItems({
        items: items,
        sortProperty: sortProperty,
        sortDirection: sortDirection,
      }),
    [sortProperty, sortDirection]
  );

  const {
    selectedQuizItem,
    isSelectedAll,
    toggleSelectAll,
    toggleItem,
    quizOrFolders: sortedQuizItems,
    selectNone,
  } = useFilteredSortedQuizListItems({
    quizListItems: quizzes.data,
    filter: getFreeQuizzesFilter(),
    sort: sortQuizItems,
  });

  return (
    <LibraryPanel
      QuizUrl={quizUrl}
      setParentId={() => {}}
      sortProperty={sortProperty}
      sortDirection={sortDirection}
      isSelectedAll={isSelectedAll}
      selectedQuizItem={selectedQuizItem}
      dispatchColumnSortAction={dispatchColumnSortAction}
      selectNone={selectNone}
      toggleSelectAll={toggleSelectAll}
      toggleItem={toggleItem}
      quizItems={sortedQuizItems}
    />
  );
}
